import { FormHelperText, useTheme } from '@mui/material';
import i18next from 'i18next';
import { isValidPhoneNumber } from 'libphonenumber-js/max';
import { Controller, useFormContext } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import { preferredCountries } from 'services/common/Constants';

const EAPhoneInput = ({ name }) => {
  const theme = useTheme();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Controller
        name={name}
        rules={{
          required: i18next.t('infos.required'),
          validate: (value) => isValidPhoneNumber('+' + value),
        }}
        // defaultValue={user.phone}
        onChange={(e) => {
          return e[0];
        }}
        control={control}
        render={({ field: { name, value, onChange, onBlur } }) => (
          <>
            <PhoneInput
              inputClass={errors[name] ? 'phone-error' : ''}
              buttonClass={errors[name] ? 'phone-error' : ''}
              inputStyle={{
                borderRadius: '12px',
                border: errors[name]
                  ? '1px solid #FFCCCC'
                  : '1px solid #E2E2EA',
                paddingLeft: '60px',
                height: '40px',
                width: '100%',
              }}
              buttonStyle={{
                backgroundColor: 'transparent',
                border: 0,
                paddingLeft: '13px',
              }}
              placeholder={'000000000'}
              country={preferredCountries[0]}
              preferredCountries={preferredCountries}
              preserveOrder={['preferredCountries']}
              countryCodeEditable={false}
              inputProps={{
                autoFocus: false,
                name,
                required: true,
              }}
              name
              enableSearch
              disableSearchIcon
              specialLabel={false}
              fullWidth
              localization={i18next.t('countries', {
                returnObjects: true,
              })}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
            />
            <FormHelperText
              style={
                errors[name] && {
                  color: theme.palette.error.main,
                  position: 'relative',
                  left: '14px',
                }
              }
            >
              {errors[name] ? i18next.t('userProfile.errorPhoneFormat') : ''}
            </FormHelperText>
          </>
        )}
      />
    </>
  );
};

export default EAPhoneInput;
